module.exports = __webpack_public_path__ + "img/step-2.9c937229.svg";